
Monet.UI = Monet.UI || {};
Monet.UI.FilterBuilder = (function () {

    function FilterBuilder() {

        this.fieldList         = null;
        this.fields            = {};
        this.url               = null;
        this.selectedFilters   = {};
        this.columnToOrder     = [];
        this.defaultFilters    = {};
        this.fieldOverrides    = null;
        this.entity            = null;
        this.selector          = null;
        this.idScreen          = null;
        this.customNameSpace   = null;
        this.el                = document.createElement('div');
        this.el.className      = 'MonetUIFilterBuilder';
        this.projection        = '{"filters":["*"]}';
        this.generateTimeRange = true;
        this.isFiltered        = false;
        this.willLoadState     = true;
        this.parentFilter      = null;
        this.fieldNameSufix    = '';
        this.childrenFilters   = [];
        this.customAdjustHeaderSize       = null;
        this.selectorContainerFilter      = null;
        this.parentFilterRelationshipType = 'BELONGS'; // valores válidos MERGE ou BELONGS
        this.customExecuteFilter = null;
        this.afterAddSelectedField = null;
        this.offsetTop = null;
        this.fieldsToDisplayOnFilterBuilder = [];
        this.allowSavePreferences = true;

        this.loading = new Monet.UI.LoadingData();

        this.filterButton = (function (scope) {
          const input = document.createElement('input');
          const baseClass = 'MonetUIFilterBuilderFilterButton';
          const isLoadingClass = `${baseClass}--isLoading`;
          input.type = 'button';
          input.className = baseClass;
          input.value = Monet.I18n.getResourcesByKey('Monet.UI.GridFilter.FilterButton');
          input.title = Monet.I18n.getResourcesByKey('Monet.UI.GridFilter.FilterButton');

          function onClick(e) {
            var entity = scope.customNameSpace || scope.entity;
            scope.isFiltered = true;
            scope.setPaginationFirstZero(entity);
            scope.executeFilter();
            scope.updateValuesSelectedFilters();
            scope.saveState();
            scope.sendSavePreferences();
            e.preventDefault();
          }

          input.addEventListener('click', onClick);

          function showLoading() {
            input.removeEventListener('click', onClick);
            input.classList.add(isLoadingClass);
            input.setAttribute('disabled', 'disabled');
          }

          function hideLoading() {
            input.addEventListener('click', onClick);
            input.classList.remove(isLoadingClass);
            input.removeAttribute('disabled');
          }

          return {
            filterButtonHTML: input,
            showLoading,
            hideLoading
          };
        })(this);

        this.setCallbacks = function (callbacks) {

            var success = function (context) {

                return function (data, token){

                    context.loading.hide();
                    callbacks.success(data, token);

                };

            }(this);

            var error = function (context) {

                return function (e){

                    context.loading.hide();
                    callbacks.error(e);

                };

            }(this);

            this.callbackSuccess = success;
            this.callbackError = error;
            this.callbackBeforeFilter = callbacks.beforeFilter;
        };

        this.setAllowSavePreferences = function (allowSavePreferences) {
            this.allowSavePreferences = allowSavePreferences;
        };

        this.setCallbackBeforeFilter = function (callbackBeforeFilter) {
            this.callbackBeforeFilter = callbackBeforeFilter;
        };

        this.setProjection = function (projection) {
            this.projection = projection;
        };

        this.setCriteriaChain = function (criteriaChain) {
            this.criteriaChain = criteriaChain;
        };

        this.setCustomNameSpace = function (nameSpace) {
            this.customNameSpace = nameSpace;
        };

        this.setEntity = function (entity) {
            this.entity = entity;
        };

        this.setWillLoadState = function (willLoadState) {
            this.willLoadState = willLoadState;
        };

        this.setGenerateTimeRange = function (timeRange) {
            this.generateTimeRange = timeRange;
        };

        this.setDefaultFilters = function (filters) {
            this.defaultFilters = filters;
        };

        this.setSelectedFilters = function (filters) {
            this.selectedFilters = filters;
        };

        this.setFieldNameSufix = function (sufix) {
            this.fieldNameSufix = sufix;
        };

        this.setcustomAdjustHeaderSize = function (adjustHeaderSize) {
            this.customAdjustHeaderSize = adjustHeaderSize;
        };

        this.setUrl = function (url) {
            this.url = url;
        };

        this.setSelectorContainertFilter = function (selectorContainertFilter) {
            this.selectorContainerFilter = selectorContainertFilter;
        };

        this.setAfterAddSelectedFilter = function (afterAddSelectedField) {
          this.afterAddSelectedField = afterAddSelectedField;
        };

        this.setFieldsToDisplayOnFilterBuilder = function (fieldsToDisplayOnFilterBuilder) {
            this.fieldsToDisplayOnFilterBuilder = fieldsToDisplayOnFilterBuilder;
        };

        this.setCustomExecuteFilter = function (customExecuteFilter) {
            this.customExecuteFilter = customExecuteFilter;
        };

        this.addChildFilters = function (childFilter) {
            this.childrenFilters.push(childFilter);
        };

        this.getTabName = function () {
            return this.idScreen || this.customNameSpace || this.entity;
        };

        this.getProjection = function () {

            var entity = (this.customNameSpace ? this.customNameSpace : this.entity);
            var projection = this.checkFieldsInProjection (this.projection);
            var pagination = (App.Forms[entity] ? App.Forms[entity].pagination : null);

            if (pagination) {

                projection.firstResult = pagination.first;
                projection.maxResults = pagination.max;

            }

            return  JSON.stringify (projection);
        };

        this.checkFieldsInProjection = function (projection) {

            var checkedProjection = JSON.parse (projection);

            var existInProjection, field, projectionField;

            for (var selectedFilter in this.selectedFilters) {

                existInProjection = false;

                field = this.fieldList[selectedFilter];

                if (field && field.meta && field.meta.hasMany) {

                    for (var i = 0, l = checkedProjection.filters.length; i < l; i++) {

                        projectionField = (field.meta.hasMany.collectionName || field.name) + '.*';

                        if (projectionField === checkedProjection.filters[i]) {
                            existInProjection = true;
                        }

                    }

                    if (!existInProjection) {

                        checkedProjection.filters.push (projectionField);
                        checkedProjection.filters.push (field.meta.hasMany.criteriaChainAttribute);

                    }

                }

            }

            return checkedProjection;

        };

        this.removeIdentifierMatchModeOfValue = function (value) {

            var _value = "";

            if (value) {

                _value = value.replace(/^\*|\*$/g, '');

            }

            return _value;

        };

        this.setFieldsByRestriction = function(restriction) {
            var criteriaFields = JSON.parse(restriction).criteriaChain[0].and || [],
                fields = {},
                fieldName = '',
                value, matchMode;

            for (var i in criteriaFields) {
                fieldName = criteriaFields[i].attr.split('.');
                matchMode = criteriaFields[i].matchMode;

                if(fieldName[1] && !criteriaFields[i].in) {
                    value = {id: criteriaFields[i].eq};
                }else {
                    value= criteriaFields[i].in || criteriaFields[i].eq;
                }

                if(matchMode === Monet.Utils.CriteriaMatchModes.ANYWHERE ){
                    value= '*' + value + '*';
                }else if (matchMode === Monet.Utils.CriteriaMatchModes.START) {
                    value += '*';
                } else if (matchMode === Monet.Utils.CriteriaMatchModes.END) {
                    value= '*' + value;
                }
                fields[fieldName[0]] = {value : value};
            }

            this.setSelectedFilters(fields);

        };

        this.getCriteriaChain = function (isSomebodysFather, childFieldList) {

            this.updateValuesSelectedFilters ();
            this.updateOrderField ();

            var filter = {
                criteriaChain: [
                    {
                        and: []
                    }
                ]
            };

            if (this.parentFilter) {
                this.parentFilter.parentFilterRelationshipType = this.parentFilterRelationshipType;
                filter = this.parentFilter.getCriteriaChain(true, this.fieldList);
            }

            var fields = this.fields;
            var parentKeyExist  = true;

            for (var key in fields) {

                if (isSomebodysFather && childFieldList) {
                    parentKeyExist = this.checkIfChildHasParentKey (key, childFieldList);
                }

                if (!isSomebodysFather || (isSomebodysFather && parentKeyExist)) {
                    this.extractInfoToMakeCriteria (key, filter, isSomebodysFather);
                }

                if (this.parentFilter && parentKeyExist) {
                    this.selectedFilters[key] = this.parentFilter.selectedFilters[key];
                }

            }

            if (this.columnToOrder.length > 0){
                filter.sort = this.columnToOrder;
            }

            return filter;

        };

        this.extractInfoToMakeCriteria = function (key, filter, isSomebodysFather) {

            var fields          = this.fields,
                field           = this.fieldList[key],
                initialCriteria = null,
                finalCriteria   = null,
                eqCriteria      = null,
                rangeTypesEnabled = ['DATE_TIME_RANGE', 'DATE_RANGE', 'TIME_RANGE', 'DECIMAL_RANGE', 'SECONDS_RANGE', 'INTEGER_RANGE', 'TOGGLENUMBER_RANGE'];

            if (rangeTypesEnabled.indexOf(field.type) !== -1 ) {

                initialCriteria = this.getInitialCriteria (fields[key], key);

                if (initialCriteria) {
                    filter.criteriaChain[0].and.push (initialCriteria);
                }

                finalCriteria = this.getFinalCriteria (fields[key], key);

                if (finalCriteria) {
                    filter.criteriaChain[0].and.push (finalCriteria);
                }

            } else if (this.fieldList[key].meta) {

                eqCriteria = this.getMetaCriteria (fields[key], key);

            } else {

                eqCriteria = this.getCriteria (fields[key], key, isSomebodysFather);

            }

            if (eqCriteria) {
                if (eqCriteria.attr === 'stop.undeliverableCode.key.id') {
                    eqCriteria.attr = 'stop.undeliverableCode.id';
                }
                this.replaceParentCriteriaWithChildCriteria (eqCriteria, filter);
                filter.criteriaChain[0].and.push(eqCriteria);

            }

        };

        this.replaceParentCriteriaWithChildCriteria = function (eqCriteria, filter) {

            var criteriaChain = filter.criteriaChain[0].and;

            for (var l = criteriaChain.length, i = 0; l > i; l--) {
                if (eqCriteria.attr === criteriaChain[l-1].attr) {
                    criteriaChain.splice(l-1, 1);
                }
            }

        };

        this.checkIfChildHasParentKey = function (key, list) {

            var sufix = '';

            if (this.fieldNameSufix) {
                sufix = this.fieldNameSufix + '.';
            }

            for (childKey in list) {
                if (childKey === key.replace(sufix, '')) {
                    return true;
                }
            }

            return false;

        };

        this.hasFieldValue = function (value) {
            var valueIsArray = (value instanceof Array);

            if (typeof value === 'string' && !value.trim().length) {
              return false;
            }

            return (( valueIsArray && value.length ) || (!valueIsArray && (value || value === 0  || value === false)));
        };

        this.getCriteria = function (field, key, isSomebodysFather) {

            var criteria = {};
            var keySufix = '';
            var fieldsTypeAnyList = ['PICKLIST_MULTISELECT', 'PICKLIST', 'LOOKUP', 'PICKLIST_MULTISELECT_FILTER', 'POWER_LOOKUP_LIST_FILTER'];
            var fieldTypeText = ['TEXT_AREA', 'TEXT', 'EMAIL', 'TEXT_EDITOR_ATTRIBUTES', 'TEXT_AREA_ATTRIBUTES'];
            var value = field.getFilterValue();
            var valueIsArray = (value instanceof Array);

            if (isSomebodysFather && this.parentFilterRelationshipType === 'BELONGS') {
                keySufix = this.entity.toLowerCase() + '.';
            }

            if (this.hasFieldValue(value)) {

                var attr = keySufix + key;

                if (fieldsTypeAnyList.indexOf(this.fieldList[key].type) !== -1) {

                    if (!(field.dataIsFieldDomain && field.dataIsFieldDomain())) {
                        attr += '.id';
                    }

                } else {

                    if (fieldTypeText.indexOf(this.fieldList[key].type) !== -1) {
                        criteria.matchMode = this.getMatchMode(value);
                        value = this.removeIdentifierMatchModeOfValue(value);
                    }

                    if (this.fieldList[key].lookupEntityColumn) {
                        attr += '.' + this.fieldList[key].lookupEntityColumn;
                    }

                }

                if (this.fieldNameSufix && isSomebodysFather) {
                    attr = attr.replace(this.fieldNameSufix + '.', '');
                }

                criteria.attr = attr;

                if (valueIsArray) {
                    criteria.in = value;
                } else {
                    criteria.eq = value;
                }

                return criteria;

            }

            return false;

        };

        this.getMatchMode = function (value) {

            var _matchMode = Monet.Utils.CriteriaMatchModes.EXACT;

            if (value){

                var lastIndexValue = value.length - 1;
                var firstChar = value[0];
                var lastChar = value[lastIndexValue];

                if (firstChar === "*" && lastChar === "*") {

                    _matchMode = Monet.Utils.CriteriaMatchModes.ANYWHERE;

                } else if (firstChar === "*" ) {

                    _matchMode = Monet.Utils.CriteriaMatchModes.END;

                } else if (lastChar === "*") {

                    _matchMode = Monet.Utils.CriteriaMatchModes.START;

                }

            }

            return _matchMode;

        };

        this.getInitialCriteria = function (field, key) {

            var criteria = {};
            var value = field.getFilterValue().ini;

            if (value) {

                criteria.gte = value;
                criteria.attr = key.replace('_Range', '');

                return criteria;

            }

            return false;

        };

        this.getFinalCriteria = function (field, key) {

            var criteria = {};
            var value = field.getFilterValue() .fin;

            if (value) {

                criteria.lte = value;
                criteria.attr = key.replace('_Range', '');

                return criteria;

            }

            return false;

        };

        this.getMetaCriteria = function (monetField, key) {
            const criteria = {};
            let value = monetField.getFilterValue();
            const entity = this.customNameSpace || this.entity;
            const field = App.Forms[entity].fields[key];
            const meta = field.meta;
            const isArray = value && value instanceof Array;
            const isText = this.fieldList[key].type === 'TEXT';
            const hasMany = meta.hasMany;

            if (this.hasFieldValue(value)) {
                if (isText) {
                    criteria.matchMode = this.getMatchMode(value);
                    value = this.removeIdentifierMatchModeOfValue(value);
                }

                if (isArray) {
                    criteria['in'] = value;
                } else {
                    criteria.eq = value;
                }

                if (hasMany) {
                    const prefix = `${hasMany.collectionName || field.name}.${hasMany.entityName}`;
                    if (isText) {
                        criteria.attr = `${prefix}.${field.lookupEntityColumn || hasMany.lookupEntityColumn || hasMany?.criteriaChainAttribute.split('.').at(-1)}`;
                    } else {
                        criteria.attr = hasMany.criteriaChainAttribute || `${prefix}.id`;
                    }
                } else {
                    criteria.attr = !!monetField.input && !!monetField.input.name ? monetField.input.name : monetField.name;
                }

                return criteria;
            }

            return false;
        };

        this.clearFilter = (function (scope){
            return function () {

                var entity = scope.customNameSpace ? scope.customNameSpace : scope.entity;
                var fields = App.Forms[entity].filterBuilder.fields;

                for (var key in fields) {

                    fields[key].clear();
                }

                scope.updateValuesSelectedFilters ();

            };
        }(this));

        this.getSort = function () {

            if(this.customNameSpace && App.Forms[this.customNameSpace]){

                var columnToOrder =  App.Forms[this.customNameSpace].columnToOrders;
                var sort = [];

                if (columnToOrder) {

                    var columnToOrderLength = columnToOrder.length;

                    for (var i = 0; i < columnToOrderLength; i++) {

                        sort.push({
                            attr: columnToOrder[i].field,
                            type: columnToOrder[i].order
                        });

                    }

                }

                return sort;
            }

        };

        this.executeFilter = function () {

            const executeFilter = () => {
                const fieldList = this.fieldList;

                const callBackExecuteFilter = function (scope) {
                    return function () {
                        scope.preventEmptyFilters();

                        scope.criteriaChain = scope.getCriteriaChain();
                        scope.projection    = scope.getProjection();
                        const sort            = scope.getSort();

                        if (scope.sort && scope.sort.length !== 0 ) {
                            scope.criteriaChain.sort = sort;
                        }

                        if (!Object.keys(scope.selectedFilters).length) {
                            scope.renderSelectedFields();
                        }

                        scope.loading.init();
                        scope.loading.show();

                        if (scope.callbackBeforeFilter) {
                            scope.callbackBeforeFilter();
                        }


                        if (!scope.customRequest) {
                            scope.defaultRequest(scope.criteriaChain, scope.projection);
                        } else {
                            scope.customRequest(scope.criteriaChain, scope.projection);
                        }
                    };
                }(this);

                if (!fieldList) {
                    this.render(callBackExecuteFilter);
                } else {
                    callBackExecuteFilter();
                }

                this.reflectParentFiltersOnChildren();
                this.executeChildren();
            };

            if (this.customExecuteFilter) {
                this.customExecuteFilter();
            } else {
                executeFilter();
            }

        };

        this.reflectParentFiltersOnChildren = function () {

            if (this.childrenFilters.length) {

                for (var child in this.childrenFilters) {

                    var currentChild             = this.childrenFilters[child];
                    var currentChildSelectFields = currentChild.selectedFilters;
                    var currentChildEntity       = currentChild.customNameSpace || currentChild.entity;

                    for (var field in this.selectedFilters) {

                        var fieldSufixed, fieldWithoutSufix;

                        if (this.fieldNameSufix) {
                            fieldWithoutSufix = field.replace(this.fieldNameSufix + '.', '');
                        }

                        fieldSufixed = field;

                        var parentKeyExist = this.checkIfChildHasParentKey (fieldWithoutSufix, currentChild.fieldList);

                        if (Object.keys(currentChildSelectFields).indexOf(fieldWithoutSufix) !== -1) {

                            App.Forms[currentChildEntity].filterBuilder.fields[fieldWithoutSufix].setValue (this.selectedFilters[fieldSufixed].value);

                        } else if (!currentChild.selectedFilters[fieldWithoutSufix] && parentKeyExist) {
                            currentChild.addSelectedFilter(
                                currentChild,
                                currentChild.fieldList[fieldWithoutSufix],
                                this.selectedFilters[fieldSufixed].value
                            );
                        }

                    }

                }

            }

        };

        this.mergeOptions = function (obj1, obj2) {

            var obj3 = {};

            for (var attrname in obj1) {
                obj3[attrname] = obj1[attrname];
            }

            for (var attrname2 in obj2) {
                obj3[attrname2] = obj2[attrname2];
            }

            return obj3;
        };

        this.executeChildren = function () {

            if (this.childrenFilters.length) {

                var executeAllChildren = function (scope) {
                    return function () {
                        for (var filter in scope.childrenFilters) {

                            var childEntity = scope.childrenFilters[filter].customNameSpace || scope.childrenFilters[filter].entity;

                            scope.childrenFilters[filter].setPaginationFirstZero(childEntity);
                            scope.childrenFilters[filter].executeFilter ();
                        }
                    };
                }(this);

                executeAllChildren ();
            }
        };

        this.changeCriteriaBeforeFilter = function (criteria) {
            return criteria;
        };

        this.defaultRequest = function (criteria, projection) {

            var token = new Date().getTime() + (Math.random() * 1000)
              , collectionFunc = App.Collections[this.entity+'s']
              , collection = new collectionFunc ();

            this.lastToken = token;

            var functionToCallback = function (scope, token) {
                return function (data) {
                    scope.callbackSuccess(data, token);
                };
            }(this, token);

            criteria = this.changeCriteriaBeforeFilter(criteria);

            collection.reset();
            collection.filterWithRestrictions({
                restrictionUrl: this.url,
                filter: criteria,
                criteria: projection,
                success: functionToCallback
            });

        };

        this.preventEmptyFilters = function () {
            this.updateValuesSelectedFilters();
            const selectedFilters = Object.values(this.selectedFilters);
            const allFiltersAreEmpty = selectedFilters.every((filter) => (
                typeof filter.value !== "object" ? !filter.value :
                    Object.values(filter.value).every(val => !val.toString().length)
            ));
            const defaultFiltersHaveValue = Object.values(this.defaultFilters).some(filter => filter.value);
            if (!selectedFilters.length || (allFiltersAreEmpty && defaultFiltersHaveValue)) {
                this.addDefaultFilters();
            }
        };

        this.addDefaultFilters = function () {
            const entity = this.customNameSpace || this.entity;
            for (const defaultItem in this.defaultFilters) {
                if (this.defaultFilters.hasOwnProperty(defaultItem)) {
                    if (!this.selectedFilters[defaultItem]) {
                        this.addItemList(this, defaultItem, this.defaultFilters[defaultItem].value);
                    } else {
                        App.Forms[entity].filterBuilder.fields[defaultItem] && App.Forms[entity].filterBuilder.fields[defaultItem].setValue(this.defaultFilters[defaultItem].value);
                    }
                }
            }
        };

        this.render = function (callbackFinishRender, doNotRenderFilter) {

            var entity = this.customNameSpace || this.entity;
            var dataMapper = new Monet.Builder.DataMapper();
            var fields = App.Forms[entity].fields;

            var callback = (function(scope, callbackFinishRender){
                return function () {

                    if (scope.customNameSpace) {
                        dataMapper.copyDataMapperToAnotherNamespace(scope.customNameSpace);
                    }

                    scope.getFieldList ();

                    var fieldListContainer = scope.renderFieldListContainer ();

                    if (fieldListContainer) {

                        while(scope.el.hasChildNodes()){
                            scope.el.removeChild(scope.el.firstChild);
                        }
                        scope.setSelectedFilters({});

                        scope.el.appendChild (fieldListContainer);
                    }

                    if (!doNotRenderFilter) {
                      scope.el.appendChild (scope.MonetUIFilterBuilderListContainer());
                      scope.el.appendChild (scope.renderAddButton());
                      scope.el.appendChild (scope.renderFilterButtonsContainer());
                    }

                    if (scope.willLoadState) {
                        scope.loadState ();
                    }

                    window.addEventListener ('resize', (function (context) {
                        return function () {
                          if (App.Forms[context.customNameSpace]) {
                            context.adjustHeaderSize ();
                          }
                        };
                    }(scope)));

                    scope.renderSpecialSelect();
                    scope.adjustHeaderSize ();

                    if(callbackFinishRender){
                        callbackFinishRender ();
                    }
                };
            }(this, callbackFinishRender));

            if(!fields) {
                dataMapper.setEntity(this.entity);
                dataMapper.getFieldList(callback);
            }  else {
                callback();
            }


        };

        this.renderSpecialSelect = function () {

            const tabName = this.getTabName();
            const tabContainer = document.getElementById(tabName);

            if(tabContainer) {
                const firstChild = tabContainer.firstChild;
                const entity = this.customNameSpace || this.entity;

                $(this.elFieldList.querySelector(' .pickListFieldFilters.fieldList')).selectpicker(
                    {
                        size: 15,
                        'callback': (function (scope) {
                            return function (val, e) {
                                e.stopPropagation();
                                scope.addItemList (scope, val, null, { shouldFocus: true });
                                $('body').trigger("click");
                            };
                        }(this)),
                        entity: entity,
                        liveSearchNormalize: true
                    }
                );

                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
                    $(this.elFieldList.querySelector(' .pickListFieldFilters.fieldList')).selectpicker('mobile');
                }
                tabContainer.insertBefore (this.elFieldList, firstChild);
            }

        };

        let timeoutId;
        this.sendSavePreferences = () => {
            timeoutId && clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                var userPreferences = new Greenmile.UserPreferences.Actions();
                userPreferences.saveOrUpdateSingleUserPreference('filters');
            }, Monet.Session.Configurations.timeToUpdate || 60000);
        };

        this.addItemList = function (scope, item, value, options) {

            var fieldList = scope.fieldList;

            if(fieldList){
                var field = fieldList[item];
                scope.addSelectedFilter(scope, field, value, options);
            }

        };

        this.toggleAddFieldButton = () => {
          const fieldList = this.elFieldList.querySelector(' select.pickListFieldFilters.fieldList');
          const entity = this.customNameSpace ? this.customNameSpace : this.entity;
          const btnAddFilter = this.el.querySelector(`#${entity}_MonetUIFilterBuilderAddButton`);

          if (btnAddFilter && (fieldList && !fieldList.options.length)) {
            btnAddFilter.style.display = 'none';
          } else if (btnAddFilter && btnAddFilter.style.display === 'none') {
            btnAddFilter.style.display = '';
          }
        }

        this.renderSelectedFields = function () {

            var fieldList = this.fieldList;

            if (this.selectedFilters) {
                for (var field in this.selectedFilters) {
                    if(this.selectedFilters.hasOwnProperty(field) && !this.fields[field]){
                        this.addSelectedFilter (this, fieldList[field], this.selectedFilters[field].value);
                    }

                }
            }

        };

        this.setSelector = function (selector) {
            this.selector = selector;
        };

        this.setIdScreen = function (idScreen) {
            this.idScreen = idScreen;
        };

        this.getFieldList = function (callback) {

            const entity = this.customNameSpace ? this.customNameSpace : this.entity;

            App.Forms[entity] = App.Forms[entity] || {};
            App.Forms[entity].filterBuilder = App.Forms[entity].filterBuilder || {};

            if (entity) {
                if (App.Forms[entity]) {
                    const baseFields = App.Forms[entity].fields;
                    let fields = baseFields;
                    let fieldsConditionedByFieldsToDisplay = {};

                    this.fieldsToDisplayOnFilterBuilder.forEach(fieldKey => {
                        const field = fields[fieldKey];

                        if (field) {
                            Object.assign(fieldsConditionedByFieldsToDisplay, { [fieldKey]: field });
                        }
                    });

                    if (Object.keys(fieldsConditionedByFieldsToDisplay).length) {
                        fields = fieldsConditionedByFieldsToDisplay;
                    }

                    if (this.fieldOverrides) {
                        for (let field in fields) {
                            fields[field].type = this.overrideNaturalFieldBehavior(fields[field].type);
                        }
                    }

                    const rangeFilters = this.generateRanges(baseFields);

                    if (this.fieldsToDisplayOnFilterBuilder.length) {
                        const enabledFieldsKeys = Object.keys(rangeFilters)
                            .filter(key => this.fieldsToDisplayOnFilterBuilder.indexOf(key) !== -1);

                        enabledFieldsKeys.forEach(key => {
                            fields[key] = rangeFilters[key];
                        });

                        this.fieldList = fields;
                    } else {
                        this.fieldList = rangeFilters;
                    }


                } else {
                    const error = new Monet.Exception.ReturnError(
                        this, 'FilterBuilder: getFieldList: DataMapper for ' + entity + ' is null'
                    );
                    error.console();
                }

            } else {
                const error = new Monet.Exception.ReturnError(
                    this, 'FilterBuilder: getFieldList: this.entity is null'
                );

                error.console();
            }

            if (callback) {
                callback ();
            }

        };

        this.generateRanges = function (dataMapper) {

            var fieldList = {},
                clonedField = null,
                fieldTypeEnableToRange = ['DATE', 'DATE_TIME', 'INTEGER', 'DECIMAL', 'SECONDS', 'TIME', 'TOGGLENUMBER'];

            for (var field in dataMapper) {

                fieldList[field] = dataMapper[field];

                if (this.generateTimeRange && fieldTypeEnableToRange.indexOf(dataMapper[field].type) > -1) {
                    clonedField = Object.create(dataMapper[field]);
                    clonedField.name = clonedField.name + '_Range';
                    clonedField.type = dataMapper[field].type + '_RANGE';
                    clonedField.label = Monet.I18n.getResourcesByKey(clonedField.label) + " " +
                                        Monet.I18n.getResourcesByKey("general.range");

                    fieldList[field + '_Range'] = clonedField;
                }
            }
            return fieldList;
        };

        this.renderFieldListContainer = function () {

            if (this.fieldList) {

                const tabName = this.getTabName();
                const entity = this.customNameSpace || this.entity;
                const existingList = document.querySelector ('#' + tabName + ' .MonetUIFilterBuilderSelectContainer.' + entity.replace(/\./g, '_'));
                let existingParent = null;

                if (existingList) {
                    existingParent = existingList.parentNode;
                    existingParent.removeChild (existingList);
                }

                this.elFieldList = document.createElement('div');
                this.elFieldList.className = 'MonetUIFilterBuilderSelectContainer ' + entity.replace(/\./g, '_');

                this.elFieldList.appendChild(this.renderFieldList());

                return this.elFieldList;

            }

            var error = new Monet.Exception.ReturnError(
                this, 'FilterBuilder: renderFieldList: this.fieldList is null'
            );

            error.console();

        };

        this.renderFieldList = function () {

            var fragment = document.createDocumentFragment();
            var select = document.createElement('select');
            select.className = 'pickListFieldFilters fieldList';
            select.setAttribute ('data-live-search', 'true');

            for (var field in this.fieldList) {

                if (this.allowAddFilter(field)) {

                    select.appendChild(this.createOptionField(this.fieldList[field]));

                }

            }

            fragment.appendChild(select);

            return fragment;

        };

        this.createOptionField = function (field){

            var option = document.createElement('option');
            var translatedOption = Monet.I18n.getResourcesByKey(field.label);
            var fieldType = field.type;

            option.value = field.name;

            option.setAttribute('name', field.name);
            option.setAttribute('label', translatedOption);
            option.setAttribute('type', fieldType);

            option.innerHTML = translatedOption;

            return option;
        };

        this.allowAddFilter = function (field) {
            const filterBlackList = {
                GeotabGeofenceImportLog: ['message'],
                HOSGeoTabSyncLog:['message', 'receivedDate', 'receivedDate_Range'],
                ProactiveRouteOptConfig: ['optimizationObjective',"prioritizeStopWithVolume","largeDeliveryPriorization","largeDeliveryPriorizationType"],
                RouteView: ['stockSize1', 'stockSize2', 'stockSize3', 'stockSize1_Range', 'stockSize2_Range', 'stockSize3_Range' ]
            }

            for (var selectedFilter in this.selectedFilters) {
                if (field === selectedFilter) {
                    return false;
                }
            }

            if (!this.checkFilterTypes(this.fieldList[field].type)) {
                return false;
            }

            if (this.entity in filterBlackList &&

                filterBlackList[this.entity].indexOf(field) > -1){

                return false;
            }

            return true;

        };

        this.checkFilterTypes = function (type) {

            switch (type) {
                case "HIDDEN":
                case "LINK":
                case "PASSWORD":
                    return false;
                default:
                    return true;
            }

        };

        this.refreshFieldList = function () {


            var select = this.elFieldList.querySelector ('select');
            var newSelect = this.renderFieldList();

            while(select.hasChildNodes()){
                select.removeChild(select.firstChild);
            }

            select.innerHTML = '';

            var optionsObj = {};

            for (var i = 0, l = newSelect.firstChild.options.length; i<l; i++) {
                optionsObj[i] = newSelect.firstChild.options[i];
            }

            for (var option in optionsObj) {
                select.appendChild (optionsObj[option]);
            }

        };

        this.MonetUIFilterBuilderListContainer = function () {

            var fieldListContainer = document.createElement('div');
            fieldListContainer.className = 'MonetUIFilterBuilderListContainer';

            return fieldListContainer;

        };

        this.renderAddButton = function () {

            const addButton = document.createElement('div');
            const entity = this.customNameSpace || this.entity;
            const tabName = this.getTabName();
            addButton.className = 'MonetUIFilterBuilderAddButton';
            addButton.id = entity + '_MonetUIFilterBuilderAddButton';
            addButton.appendChild(document.createTextNode('+'));
            addButton.addEventListener('click', (function (scope, entity) {
                return function (e) {
                    e.preventDefault ();
                    e.stopPropagation ();

                    const tabId = '#' + tabName;
                    const containerSelector = tabId + ' .MonetUIFilterBuilderSelectContainer.' + entity.replace(/\./g, '_');
                    const dropDowns = document.querySelectorAll (containerSelector + ' .btn-group.bootstrap-select.pickListFieldFilters.fieldList');

                    $(tabId + ' .pickListFieldFilters').selectpicker('refresh');
                    $(tabId + ' .pickListFieldFilters').selectpicker('show');

                    $(document.querySelector(containerSelector + ' .btn.dropdown-toggle.btn-default')).trigger("click");

                    for (let i = 0, l = dropDowns.length; i < l; i++) {
                        dropDowns[i].style.left = scope.calculateMenuPosition(e) + 'px';
                        dropDowns[i].style.top = (e.clientY-27) + 'px';

                        //check and fix dropdown position and height if its covered by footer
                        const dropdownList = dropDowns[i].querySelector('.dropdown-menu.inner');

                        const dropdownBottom = dropdownList ? dropDowns[i].offsetTop + parseInt(dropdownList.style.maxHeight.split('px')[0]) + 60 : null;
                        if (dropdownBottom) {
                            const newHeight = dropDowns[i].offsetTop - 60;
                            if (newHeight > 100) {
                                dropdownList.style.height = newHeight + 'px';
                            } else {
                                dropdownList.style.height = '100px';
                                dropDowns[i].style.top = (160) + 'px';
                            }
                        }
                        else if (dropdownList) {
                            dropdownList.style.height = '';
                        }
                    }



                };
            }(this, entity)));

            return addButton;

        };

        this.calculateMenuPosition = function (e) {

            var x = 0;

            if (e.clientX + 250 > window.innerWidth) {
                x = e.clientX - 240;
            } else {
                x = e.clientX + 20;
            }

            return x;

        };


        this.renderRemoveButton = function () {

            var removeButton = document.createElement('div');
            removeButton.className = 'MonetUIFilterBuilderRemoveButton';
            removeButton.id = this.entity + '_MonetUIFilterBuilderRemoveButton';
            removeButton.appendChild(document.createTextNode('-'));

            return removeButton;
        };

        this.renderFilterButtonsContainer = function () {

            var filterBtnContainer = document.createElement('div');
            filterBtnContainer.className = 'MonetUIFilterBuilderFilterButtonContainer';

            filterBtnContainer.appendChild(this.renderFilterButton());
            filterBtnContainer.appendChild(this.renderClearFilter());

            return filterBtnContainer;

        };

        this.renderFilterButton = function () {
          return this.filterButton.filterButtonHTML;
        };

        this.setPaginationFirstZero = function (entity) {

            var pagination = (App.Forms[entity]? App.Forms[entity].pagination : null);
            if(pagination){
                pagination.first = 0;
            }
        };

        this.renderClearFilter = function () {

            var clearButton = document.createElement('input');
            clearButton.type = 'button';
            clearButton.className = 'MonetUIFilterBuilderClearButton';
            clearButton.value = Monet.I18n.getResourcesByKey ('Monet.UI.GridFilter.ClearButton');
            clearButton.title = Monet.I18n.getResourcesByKey ('Monet.UI.GridFilter.ClearButton');

            clearButton.addEventListener('click', (function (scope) {
                return function (e) {
                    scope.clearFilter();
                    scope.saveState();
                    e.preventDefault();
                };
            }(this)));

            return clearButton;

        };

        this.removeFilter = function (btn, filter, selectedItem) {

            var parentBtn = btn.parentNode;
            var parentField = filter.parentNode;
            var parentContainer = parentField.parentNode;
            var entity = null;

            if (this.customNameSpace) {
                entity = this.customNameSpace;
            } else {
                entity = this.entity;
            }

            delete this.selectedFilters[selectedItem.name];
            delete App.Forms[entity].filterBuilder.fields[selectedItem.name];

            parentBtn.removeChild(btn);
            parentField.removeChild(filter);

            parentContainer.removeChild(parentBtn);

            this.adjustHeaderSize();

        };

        this.setFieldsOverride = function (overrides) {
            this.fieldOverrides = overrides;
        };

        this.overrideNaturalFieldBehavior = function (field) {

            if (this.fieldOverrides && field && this.fieldOverrides[field]) {
                return this.fieldOverrides[field];
            }

            if (field) {
                return field;
            }

            return '';

        };

        this.addSelectedFilter = function (scope, selectedItem, defaultValue, options) {

            var removeBtn = this.renderRemoveButton();
            var filterContainer = document.createElement('div');
            var btnAdds = scope.el.querySelectorAll ('.MonetUIFilterBuilderAddButton');
            var btnAdd = btnAdds[btnAdds.length-1];
            var option;
            var select = this.elFieldList.querySelector('select');
            var fieldRender = null;
            var fields = scope.fields;
            var fieldName;
            var field;
            var entity = this.customNameSpace || this.entity;

            if (selectedItem) {
                option = this.elFieldList.querySelector ('[name="'+selectedItem.name+'"]');
            }
            filterContainer.className = 'MonetUIFilterBuilderFilterContainer';

            if (selectedItem) {

                fieldName = selectedItem.name;
                field = fields[fieldName];

                if(!field) {
                    fieldRender = new Monet.UI.Fields.Render(selectedItem, this.entity, {isFilterBuilder: true});
                    field = fieldRender.render();

                    fields[fieldName] = field;
                }

                if (defaultValue) {

                    // A partir de agora os lookups no filter builder poderão ser tipo text
                    // esse método limpa o que havia sido salvo anteriormente, pois do contrário
                    // ele exibirá [object Object] no text field
                    // nas versoes posteriores a 4.6 esse código poderá ser retirado
                    // implementado por adalto.junior@sagaranatech.com

                    if (selectedItem.type === 'TEXT' && (defaultValue === "[object Object]" || typeof defaultValue === 'object')) {
                        defaultValue = "";
                    }

                    field.setValue (defaultValue);
                }

                field.rootEl.classList.add('MonetUIFilterBuilderFilterEl');
                if(field.input) {
                    field.input.addEventListener('keydown', function (e) {
                        if ( e.keyCode === 13 ) {
                            this.setPaginationFirstZero(entity);
                            this.executeFilter();
                            this.saveState();
                        }
                      }.bind(this));
                }

                if (field?.input?.type === 'checkbox') {
                    const element = field.rootEl;
                    element.style.width = 'auto';
                }

                if ( selectedItem.type.indexOf('RANGE') > -1) {
                    field.rootEl.classList.add('Range');
                }

                var translatedLabel = Monet.I18n.getResourcesByKey(selectedItem.label);
                field.rootEl.setAttribute('fieldName', selectedItem.label);
                field.rootEl.setAttribute('alt', translatedLabel);
                field.rootEl.setAttribute('title', translatedLabel);

                removeBtn.addEventListener('click', (function (scope, field) {
                    return function (e) {
                        if (field) {
                            e.preventDefault();
                            scope.removeFilter(this, field.rootEl, selectedItem);
                            scope.refreshFieldList();
                            scope.sendSavePreferences();
                            scope.toggleAddFieldButton();
                        }
                    };
                }(this, field)));

                filterContainer.appendChild(field.rootEl);
                filterContainer.appendChild(removeBtn);

                scope.el.insertBefore(filterContainer, btnAdd);

                const rangeFieldInput = field.inputIni && (field.inputIni.input || field.inputIni);

                const filterInput = rangeFieldInput || field.formattedValue || field.input;

                if (filterInput && options && options.shouldFocus) {
                    filterInput.focus();
                }

                if (!this.selectedFilters[selectedItem.name]) {
                    this.selectedFilters[selectedItem.name] = {};
                }

            }

            this.adjustHeaderSize();

            if (field && field.postRender) {
                field.postRender();
            }

            if (option) {
                select.removeChild (option);
            }

            this.toggleAddFieldButton();

            if (this.afterAddSelectedField) {
              this.afterAddSelectedField(selectedItem);
            }

        };

        this.adjustHeaderSize = function () {

            if (this.customAdjustHeaderSize) {
                this.customAdjustHeaderSize ();
            } else {
                const tabName = this.getTabName();
                const selectorContainerFilter = this.selectorContainerFilter || '#' + tabName + ' .gridActions.ui-widget-header';
                const header = document.querySelector(selectorContainerFilter);

                const selector = this.selector || '#' + this.entity + ' #table_view_container .display.ui-widget';
                const height = header?.offsetHeight || 0;

                const grid = document.querySelector(selector);

                if (grid && header) {
                    const extraHeightGap = this.customNameSpace === 'RouteProgress' ? 15 : 0;

                    this.offsetTop =  this.offsetTop ||  header.offsetTop;
                    grid.style.top = this.offsetTop + header.offsetHeight + 'px';
                    grid.style.height = `calc(100% - ${(height + extraHeightGap + header.offsetTop)}px)`;
                }

                if (this.customNameSpace && App.Forms[this.customNameSpace].table) {

                    App.Forms[this.customNameSpace].table.resizeCanvas();

                } else {

                    if (App.Forms[this.entity] && App.Forms[this.entity].table) {
                        App.Forms[this.entity].table.resizeCanvas();
                    }

                }
            }

            if (this.childrenFilters) {
                for (const filter in this.childrenFilters) {
                    this.childrenFilters[filter].adjustHeaderSize ();
                }
            }

        };

        this.saveSelectedFilters = (filters) => {
            const namespace = this.customNameSpace || this.entity;
            const sessionUserId = Monet.Session.User.id;

            if (Object.keys(this.selectedFilters).length > 0) {
                filters[sessionUserId][namespace] = this.selectedFilters;
            } else {
                delete filters[sessionUserId][namespace];
            }

            Monet.Session.sessionStorage.filters = JSON.stringify(filters);
        };

        this.saveState = function () {
            if (!this.allowSavePreferences) {
                return;
            }

            const storageFilter = Monet.Session.sessionStorage.filters;

            if (storageFilter) {
              try {
                const filters = this.parseFilters(storageFilter);
                const filter = this.getFilterForThisUserAndScreen(filters);
                if (filter) {
                    this.saveSelectedFilters(filters);
                    const userPreferences = new Greenmile.UserPreferences.Actions();
                    userPreferences.saveOrUpdateSingleUserPreference('filters');
                } else {
                    this.saveInitialState();
                }
              } catch (error) {
                const errorMessage = new Monet.Exception.ReturnError(
                  this, 'FilterBuilder: saveState: error at save state.'
                );
                errorMessage.console();
              }
            } else {
                this.saveInitialState();
            }

            Monet.Session.sessionStorage.GMLocalStorageVersion = App.Version.GMLBuildNumber || "";
            Monet.Session.sessionStorage.isUpdated = "false";
        };

        this.parseFilters = function (storageFilters) {
            try {
                return JSON.parse(storageFilters);
            } catch (error) {
                delete Monet.Session.sessionStorage.filters;
                const errorMessage = new Monet.Exception.ReturnError(
                    this, 'FilterBuilder: parseFilters: error parsing user filters'
                );
                errorMessage.console();
                return {};
            }
        };

        this.saveInitialState = function () {
            const storageFilters = Monet.Session.sessionStorage.filters;
            const sessionUserId = Monet.Session.User.id;
            let filters = {};

            if (storageFilters) {
                filters = this.parseFilters(storageFilters);
            }

            filters[sessionUserId] = filters[sessionUserId] || {};
            this.saveSelectedFilters(filters);
        };

        this.loadState = function () {

            if (Monet.Session.sessionStorage.GMLocalStorageVersion !== App.Version.GMLBuildNumber) {
                Monet.Session.sessionStorage.GMLocalStorageVersion = App.Version.GMLBuildNumber || '';
                Monet.Session.sessionStorage.isUpdated = "false";
            }

            var storageFilter = Monet.Session.sessionStorage.filters;
            var filter = null;
            const entity = this.customNameSpace || this.entity;
            var storageFilterObj = {};
            var numberOfSelectedFielters = 0;

            if (storageFilter) {
                storageFilterObj = this.parseFilters(storageFilter);
            }

            if (storageFilterObj[Monet.Session.User.id] && storageFilterObj[Monet.Session.User.id][entity]) {
                numberOfSelectedFielters = Object.keys(storageFilterObj[Monet.Session.User.id][entity]);
            }

            if (numberOfSelectedFielters.length) {

                filter = this.getFilterForThisUserAndScreen(storageFilterObj);

                if (filter) {

                    this.setSelectedFilters(filter);

                } else {

                    this.saveState(this.selectedFilters);

                }

                for (var selectedFilter in this.selectedFilters) {

                    this.addItemList(this, selectedFilter, this.selectedFilters[selectedFilter].value);

                }

            } else {

                this.saveState(this.defaultFilters);

                this.addDefaultFilters ();

            }



        };

        this.clearFiltersToNamespace = function (namespace) {
            let filters = Monet.Session.sessionStorage.filters;
            const userId = Monet.Session.User.id;
            const userPreferences = new Greenmile.UserPreferences.Actions();

            if (namespace && filters) {
                filters = this.parseFilters(filters);
                if (filters[userId] && filters[userId][namespace]) {
                    filters[userId][namespace] = {};
                    Monet.Session.sessionStorage.setItem('filters', JSON.stringify(filters));
                    Monet.Session.sessionStorage.setItem('isUpdated', "false");
                    userPreferences.saveOrUpdateSingleUserPreference('filters');
                    userPreferences.saveOrUpdateSingleUserPreference('isUpdated');
                }
            }
        };

        this.getFilterForThisUserAndScreen = function (filters) {
          const entity = this.customNameSpace || this.entity;
          if (filters[Monet.Session.User.id] && filters[Monet.Session.User.id][entity]) {
            const filter = filters[Monet.Session.User.id][entity];
            return (Object.keys(filter).length) ? filter : false;
          }
          return false;
        };

        this.updateValuesSelectedFilters = function () {

            const entity = this.customNameSpace || this.entity;

            if (App.Forms[entity].filterBuilder){

                var fields = App.Forms[entity].filterBuilder.fields;
                var allAvailableFields = App.Forms[entity].fields;
                var fieldName;
                var fieldtype;
                var value;

                for (var field in fields) {

                    fieldName = field.replace ('_Range', '');
                    fieldtype = allAvailableFields[fieldName].type;

                    if ( ['LOOKUP', 'LOOKUP_LIST', 'POWER_LOOKUP_LIST_FILTER'].indexOf(fieldtype) === -1 ) {
                        value= fields[field].getValue ();
                    } else {
                        value= fields[field].getFullValue ();
                    }

                    this.selectedFilters[field] = {
                        value: value
                    };
                }
            }

        };

        this.updateOrderField = function(){

            const entity = this.customNameSpace || this.entity;
            var list = App.Forms[entity].columnToOrders;

            this.columnToOrder = [];

            if(list){
                for(var x = 0, size = list.length; x < size; x++){
                    this.columnToOrder.push({attr: list[x].field, type: list[x].order});
                }
            }

        };

        this.postRender = (function (scope) {
            return function () {
              scope.adjustHeaderSize();
            };
        }(this));
    }

    return FilterBuilder;

}());
